<script>
import {mapActions, mapState} from "vuex";
import EmissionComplementModal from "./dialogs/EmissionComplementModal.vue";
import TraderComplementModal from "./dialogs/TraderComplementModal.vue";
import NoneReportTraderComplementModal from "./dialogs/NoneReportTraderComplementModal.vue";
import PublicPlaceComplementModal from "./dialogs/PublicPlaceComplementModal.vue";
import CustomPagination from "../../components/_CustomPagination.vue";
import Confirm from '../../../components/Confirm'
import ItemAutocomplete from "@/driver/components/ItemAutocomplete.vue";

export default {
  name: "TransferManifests",
  components: {
    EmissionComplementModal,
    TraderComplementModal,
    NoneReportTraderComplementModal,
    PublicPlaceComplementModal,
    CustomPagination,
    Confirm,
    ItemAutocomplete,
  },
  mixins: [],
  props: {},
  data() {
    return {
      page: 1,
      totalVisible: 7,
      /* 検索ブロック表示制御 */
      conditionPanel: null,
      selectedManifests: [],
      selectableIds: [],
      disabledCount: 0,
      defaultManifestId: null,
      /* 紐付け処理中フラグ */
      isAutoConfiguring: false,
      /* 排出事業者データ補完 */
      emissionComplement: false,
      /* 収運・処分業者データ補完 */
      traderComplement: false,
      /* 報告不要業者データ補完 */
      noneReportTraderComplement: false,
      /* 公共事業場データ補完 */
      publicPlaceComplement: false,
      tableHeaders: [
        { text: "マニフェスト番号", value: "manifest_no" },
        { text: "照会日\r\n排出/業者/不要/公共", value: "status", align: "center",width: "8%" },
        { text: "加入者番号\r\n排出事業者名", value: "jwnet_emission" },
        { text: "DXE事業者コード\r\nDXE排出事業者名", value: "dxe_emission" },
        { text: "排出事業場名", value: "jwnet_location_name" },
        { text: "引渡し日\r\n取扱品目名", value: "collected_date" },
        { text: "数量\r\n数量単位", value: "quantity" },
        { text: "処分事業場名\r\n処分方法", value: "quantity_confirm" },
        { text: "最終区間\r\n運搬終了日", value: "completed_date" },
        { text: "処分終了日\r\n最終処分日", value: "disposal_date" },
        { text: "詳細", value: "actions", align: "end" }
      ],
      transferManifests: [],
      /* 一覧取得日時 */
      searched_at: null,
      searchForm: {
        /* マニフェスト番号 */
        manifest_no: null,
        /* 照会日(開始日) */
        import_from_date: null,
        /* 照会日(終了日) */
        import_to_date: null,
        /* 引渡し日(開始日) */
        collected_from_date: null,
        /* 引渡し日(終了日) */
        collected_to_date: null,
        /* 加入者番号 */
        subscriber_number: null,
        /* 排出事業者名 */
        emission_name: null,
        /* 排出事業場名 */
        emission_location_name: null,
        // /* 収集運搬業者(加入者番号) */
        // transporter_subscriber_number: null,
        /* 収集運搬業者(名称) */
        transporter_name: null,
        // /* 処分場(id) ※ 事業場展開で使用 */
        // disposer_id: null,
        // /* 処分場(加入者番号) */
        // disposer_subscriber_number: null,
        /* 処分場(名称) */
        disposer_name: null,
        /* 処分事業場コード */
        disposer_location_name: null,
        // /* 処分事業場コード */
        // trader_location_key: null,
        /* JWNET取扱品目 */
        item_ids: [],
        /* 運搬報告状況 */
        transport_report_state: null,
        /* 運搬終了日(開始日) */
        transport_completed_from_date: null,
        /* 運搬終了日(終了日) */
        transport_completed_to_date: null,
        /* 運搬報告区間指定 */
        section_no: null,
        /* 取込済みを含む */
        with_imported: false,
        /* 非表示を含む */
        with_hidden: false,
        /* 処分報告状況 */
        disposal_report_state: null,
        /* 処分終了日(開始日) */
        disposal_completed_from_date: null,
        /* 処分終了日(終了日) */
        disposal_completed_to_date: null,
        /* 最終報告状況 */
        final_report_state: null,
        /* 最終終了日(開始日) */
        final_disposal_from_date: null,
        /* 最終終了日(終了日) */
        final_disposal_to_date: null,
        /* 表示順 */
        sort_type: 'updated_date_desc',
        /* 完全一致済み */
        exact_matched: false,
        /* 排出業者一致済み */
        emission_matched: false,
        /* 処分業者一致済み */
        disposer_matched: false,
        /* 未紐付け(排出事業者) */
        supplierable_state_unlinked: false,
        /* 未紐付け(業者) */
        trader_state_unlinked: false,
        /* 未紐付け(報告不要業者) */
        none_reporting_state_unlinked: false,
        /* 未紐付け(公共事業場) */
        public_place_state_unlinked: false,

        /* 表示件数 */
        limit: 15,
      },
      items: [],
      traderLocations: [],
      importErrorMessages: [],
      enableImportErrorMessageDialog: false,
      /** 運搬報告状況 */
      transportReportStatus: [
        { value: 'self_unreported', text: '自社未報告' },
        { value: 'other_unreported', text: '他社未報告' },
        { value: 'reported', text: '報告済' },
      ],
      sectionNos: [
        { value: 1, text: '第１区間' },
        { value: 2, text: '第２区間' },
        { value: 3, text: '第３区間' },
        { value: 4, text: '第４区間' },
        { value: 5, text: '第５区間' },
      ],
      /** 処分報告状況 */
      disposalReportStatus: [
        { value: "self_unreported_jwnet", text: "自社未報告(JWNET未報告)" },
        { value: "self_unreported", text: "自社未報告(JWNET報告済を含む)" },
        { value: "other_unreported", text: "他社未報告" },
        { value: "reported", text: "報告済" },
      ],
      /** 最終報告状況 */
      finalReportStatus: [
        { value: "self_unreported_jwnet", text: "自社未報告(JWNET未報告)" },
        { value: "self_unreported", text: "自社未報告(JWNET報告済を含む)" },
        { value: "other_unreported", text: "他社未報告" },
        { value: "reported", text: "報告済" },
      ],
      /** 表示順 */
      sortTypes: [
        { value: 'updated_date_desc', text: '更新日（降順）▼' },
        { value: 'updated_date_asc', text: '更新日（昇順）▲' },
        { value: 'manifest_inquiry_date_desc', text: '照会日（降順）▼' },
        { value: 'manifest_inquiry_date_asc', text: '照会日（昇順）▲' },
        { value: 'collected_date_desc', text: '引渡し日（降順）▼' },
        { value: 'collected_date_asc', text: '引渡し日（昇順）▲' },
      ],
    }
  },
  computed: {
    ...mapState('DriverTransfer', {
      pagination: 'pagination',
      searchCondition: 'condition',
    }),

    enableCallButton () {
      return !(this.selectedManifests.length > 0)
    },
  },
  watch: {
    transferManifests: {
      handler: function () {
        this.disabledCount = 0
        this.transferManifests.map(item => {
          if (item.disabled) this.disabledCount += 1
        })
      },
      deep: true
    },
    selectedManifests (values) {
      this.selectableIds = []
      if (values) {
        for (const value of values) {
          this.selectableIds.push(value.id)
        }
      }
    },
  },
  created() {
    if (this.$route.params.resetCondition) {
      this.resetCondition();
    }
    if (this.$route.params.resetPagination) {
      this.resetPagination()
    }
    this.searchForm = this.searchCondition;
    this.fetchItems().then((content) => { this.items = content.items });
    this.searchTransferManifests();
  },
  methods: {
    ...mapActions("DriverTransfer", {
      fetchTransferManifest: "index",
      resetCondition: "resetCondition",
      resetPagination: "resetPagination",
    }),
    ...mapActions("DriverTransferImport", {
      bulkImport: "create",
    }),
    ...mapActions("DriverTransferRemove", {
      bulkDelete: "update",
    }),
    ...mapActions("DriverTransferAutoConfiguration", {
      executeAutoConfiguration: "update",
    }),
    ...mapActions('DriverMasterSearchItem', {
      fetchItems: 'fetchWholeItems',
    }),
    ...mapActions('DriverMasterSearchTraderLocation', {
      fetchTraderLocations: 'index',
    }),
    /**
     * 一覧ヘッダーチェックボックス クリックイベント
     * @param props
     */
    selectAllToggleClickEvent (props) {
      if (this.selectedManifests.length !== this.transferManifests.length - this.disabledCount) {
        this.selectedManifests = []
        props.items.forEach(item => {
          if (!item.disabled) this.selectedManifests.push(item)
        })
      } else {
        this.selectedManifests = []
      }
    },
    /**
     * 行選択トグル
     */
    toggleRowSelection(item) {
      // disabledな行は選択不可
      if (item.disabled) {
        return;
      }

      const index = this.selectedManifests.findIndex(row => row === item);
      if (index > -1) {
        // 既に選択されている場合は削除
        this.selectedManifests.splice(index, 1);
      } else {
        // 選択されていない場合は追加
        this.selectedManifests.push(item);
      }
    },
    /**
     * 検索ボタン クリックイベント
     */
    searchButtonClickEvent () {
      this.page = 1;
      this.selectedManifests = null;
      this.selectedManifests = [];
      this.searchTransferManifests();
    },
    /**
     * 紐付け処理ボタン クリックイベント
     */
    autoConfigurationButtonClickEvent () {
      // 処理中は実行しない
      if (this.isAutoConfiguring) {
        return;
      }

      let modalOption = { title: '紐付け処理', message: 'マニフェストの紐付け処理を行います。よろしいですか？', options: { titleColor: 'blue', width: 450 } }
      this.$refs.confirm.open(modalOption).then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.autoConfigurationCallback();
        }
      })
    },
    /**
     * 詳細ボタン クリックイベント
     * @param item
     */
    showButtonClickEvent (item) {
      let params = { id: item.id }
      this.$router.push({name: 'DriverTransfer', params: params})
    },
    /**
     * 排出事業者ボタン クリックイベント
     * 排出事業者データ補完モーダルを表示する.
     */
    emissionComplementButtonClickEvent () {
      this.emissionComplement = true;
    },
    /**
     * 収運・処分業者ボタン クリックイベント
     * 収運・処分業者データ補完モーダルを表示する.
     */
    traderComplementButtonClickEvent () {
      this.traderComplement = true;
    },
    /**
     * 報告不要業者ボタン クリックイベント
     * 報告不要業者データ補完モーダルを表示する.
     */
    noneReportingComplementButtonClickEvent () {
      this.noneReportTraderComplement = true;
    },
    /**
     * 公共事業場ボタン クリックイベント
     * 公共事業場データ補完モーダルを表示する.
     */
    publicPlaceComplementButtonClickEvent () {
      this.publicPlaceComplement = true;
    },
    /**
     * 削除ボタン クリックイベント
     */
    deleteManifestButtonClickEvent() {
      let modalOption = { title: '削除', message: '削除されたマニフェストは取込対象外となります。よろしいですか？', options: { titleColor: 'red' } }
      this.$refs.confirm.open(modalOption).then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.bulkDeletes();
        }
      })
    },
    /**
     * 取込ボタン クリックイベント
     */
    importManifestButtonClickEvent() {
      let modalOption = { title: '取込', message: '取込します。よろしいですか？', options: { titleColor: 'blue' } }
      this.$refs.confirm.open(modalOption).then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.bulkImports();
        }
      })
    },
    /**
     * ページ チェンジイベント
     * @param page { Number }
     */
    pageChangeEvent (page) {
      this.page = page;
      this.selectedManifests = null;
      this.selectedManifests = [];
      this.searchTransferManifests();
    },
    /**
     * 一覧表示件数 チェンジイベント
     * @param perPage { Number }
     */
    perPageChangeEvent (perPage) {
      this.searchForm.limit = perPage;
      this.selectedManifests = null;
      this.selectedManifests = [];
      this.page = 1;
      this.searchTransferManifests();
    },
    /**
     * モーダル閉じるボタン コールバック
     */
    dialogCloseCallback () {
      this.emissionComplement = false;
      this.traderComplement = false;
      this.noneReportTraderComplement = false;
      this.publicPlaceComplement = false;
      this.enableImportErrorMessageDialog = false
    },
    /**
     * 各種モーダルのコールバック
     */
    dialogRegisterCallback () {
      this.searchTransferManifests()
    },
    /**
     * 自動紐付更新 確認モーダルコールバック
     */
    autoConfigurationCallback () {
      // 既に処理中の場合は実行しない
      if (this.isAutoConfiguring) {
        console.warn('autoConfigurationCallback: Already processing');
        return;
      }

      this.isAutoConfiguring = true;

      this.executeAutoConfiguration({params: { searched_at: this.searched_at }})
        .then(() => {
          this.dialogRegisterCallback();
        })
        .catch((error) => {
          console.error('Auto configuration error:', error);
        })
        .finally(() => {
          this.isAutoConfiguring = false;
        });
    },
    /**
     * 引渡し日（from）変更　コールバック
     */
    collectedFromDateChangedCallback (value) {
      this.searchForm.collected_from_date = value;
      this.searchButtonClickEvent();
    },
    collectedFromDateClearEvent () {
      this.searchForm.collected_from_date = null;
      this.searchButtonClickEvent();
    },
    /**
     * 引渡し日（to）変更　コールバック
     */
    collectedToDateChangedCallback (value) {
      this.searchForm.collected_to_date = value;
      this.searchButtonClickEvent();
    },
    collectedToDateClearEvent () {
      this.searchForm.collected_to_date = null;
      this.searchButtonClickEvent();
    },
    /**
     * 照会日（from）変更　コールバック
     */
    importFromDateChangedCallback (value) {
      this.searchForm.import_from_date = value;
      this.searchButtonClickEvent();
    },
    importFromDateClearEvent () {
      this.searchForm.import_from_date = null;
      this.searchButtonClickEvent();
    },
    /**
     * 照会日（to）変更　コールバック
     */
    importToDateChangedCallback (value) {
      this.searchForm.import_to_date = value;
      this.searchButtonClickEvent();
    },
    importToDateClearEvent () {
      this.searchForm.import_to_date = null;
      this.searchButtonClickEvent();
    },
    /**
     * 運搬終了日（from）変更　コールバック
     */
    transportCompletedFromDateChangedCallback (value) {
      this.searchForm.transport_completed_from_date = value;
      this.searchButtonClickEvent();
    },
    transportCompletedFromDateClearEvent () {
      this.searchForm.transport_completed_from_date = null;
      this.searchButtonClickEvent();
    },
    /**
     * 運搬終了日（to）変更　コールバック
     */
    transportCompletedToDateChangedCallback (value) {
      this.searchForm.transport_completed_to_date = value;
      this.searchButtonClickEvent();
    },
    transportCompletedToDateClearEvent () {
      this.searchForm.transport_completed_to_date = null;
      this.searchButtonClickEvent();
    },
    /**
     * 処分終了日（from）変更　コールバック
     */
    disposalCompletedFromDateChangedCallback (value) {
      this.searchForm.disposal_completed_from_date = value;
      this.searchButtonClickEvent();
    },
    disposalCompletedFromDateClearEvent () {
      this.searchForm.disposal_completed_from_date = null;
      this.searchButtonClickEvent();
    },
    /**
     * 処分終了日（to）変更　コールバック
     */
    disposalCompletedToDateChangedCallback (value) {
      this.searchForm.disposal_completed_to_date = value;
      this.searchButtonClickEvent();
    },
    disposalCompletedToDateClearEvent () {
      this.searchForm.disposal_completed_to_date = null;
      this.searchButtonClickEvent();
    },
    /**
     * 最終処分終了日（from）変更　コールバック
     */
    finalDisposalFromDateChangedCallback (value) {
      this.searchForm.final_disposal_from_date = value;
      this.searchButtonClickEvent();
    },
    finalDisposalFromDateClearEvent () {
      this.searchForm.final_disposal_from_date = null;
      this.searchButtonClickEvent();
    },
    /**
     * 最終処分終了日（to）変更　コールバック
     */
    finalDisposalToDateChangedCallback (value) {
      this.searchForm.final_disposal_to_date = value;
      this.searchButtonClickEvent();
    },
    finalDisposalToDateClearEvent () {
      this.searchForm.final_disposal_to_date = null;
      this.searchButtonClickEvent();
    },
    /**
     * JWNETマニフェスト一覧検索
     */
    searchTransferManifests () {
      /**
       * @var content { Object }
       * @param content.transfer_manifests { Array }
       * @param content.searched_at { Number }
       */
      this.fetchTransferManifest({ params: this.searchForm, page: this.page }).then((content) => {
        this.transferManifests = content.transfer_manifests
        this.searched_at = content.searched_at
      })
    },
    /**
     * 取込処理
     */
    bulkImports () {
      let targetManifestIds = [];
      for (const argument of this.selectedManifests) {
        targetManifestIds.push(argument.id);
      }
      const params = { jwnet_manifest_ids: targetManifestIds, searched_at: this.searched_at }
      this.bulkImport({ params: params }).then((data) => {
        const messages = data.result.message;
        if (messages.length > 0) {
          this.importErrorMessages = messages
          this.enableImportErrorMessageDialog = true
        }
        const processed_ids = data.content.processed_ids;
        // 一覧選択したマニフェストIDが、レスポンスに含まれる「登録済」のマニフェストIDの配列に存在する場合は削除する.
        if (processed_ids && processed_ids.length > 0) {
          this.selectedManifests = this.selectedManifests.filter(value => !processed_ids.includes(value.id))
        }
        this.searchTransferManifests();
      })
    },
    /**
     * 削除処理
     */
    bulkDeletes () {
      let targetManifestIds = [];
      for (const argument of this.selectedManifests) {
        targetManifestIds.push(argument.id);
      }
      const params = { jwnet_manifest_ids: targetManifestIds, searched_at: this.searched_at }
      this.bulkDelete({ params: params }).then(() => {
        this.selectedManifests = null;
        this.selectedManifests = [];
        this.searchButtonClickEvent();
      })
    },
    /**
     * 一覧 排出/業者/不要/公共のアイコン表示
     * @param item
     * @returns {string}
     */
    iconMarker (item) {
       let returnValue = "";
       if (item === "negative") {
         returnValue = "mdi-triangle";
       } else if (item === "pending") {
         returnValue = "mdi-circle";
       } else if (item === "positive") {
         returnValue = "mdi-circle";
       } else if (item === 'untouched') {
         returnValue = 'mdi-circle-small';
       } else {
         returnValue = "mdi-minus";
       }
       return returnValue;
    },
    iconColor (item) {
       let returnValue = "";
       if (item === "negative") {
         returnValue = "yellow accent-3";
       } else if (item === "pending") {
         returnValue = "warning";
       } else if (item === "positive") {
         returnValue = "primary";
      } else {
         returnValue = "black";
       }
      return returnValue;
    },
  }
}
</script>

<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <h2>
          <v-icon class="mr-2">
            mdi-application-import
          </v-icon>
          JWNETデータ取込
        </h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-expansion-panels accordion>
          <v-expansion-panel>
            <v-expansion-panel-header
              class="panel-header-color panel-selectable"
            >
              <strong>
                <v-icon class="panel-header-color"> mdi-magnify </v-icon>
                &nbsp;条件を指定して検索
              </strong>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text>
                  <!-- マニフェスト番号, 照会日, 終了日, 引渡し日, 終了日 -->
                  <v-row>
                    <v-col cols="12" md="2">
                      <v-text-field
                        v-model="searchForm.manifest_no"
                        dense
                        hide-details="auto"
                        label="マニフェスト番号"
                        outlined
                        persistent-hint
                        persistent-placeholder
                        rounded
                        clearable
                        placeholder="カンマ区切りで入力"
                        hint="例)11111,22222,33333"
                        style="font-size: 80%"
                        @blur="searchButtonClickEvent"
                        @click:clear="() => {searchForm.manifest_no = null; searchButtonClickEvent();}"
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <cs-date-picker
                        :date.sync="searchForm.import_from_date"
                        @dateChangedCallback="importFromDateChangedCallback"
                      >
                        <template v-slot="{ on, attrs }">
                          <v-text-field
                            v-model="searchForm.import_from_date"
                            v-bind="attrs"
                            v-on="on"
                            append-icon="mdi-calendar"
                            clearable
                            dense
                            hide-details="auto"
                            label="照会日"
                            outlined
                            persistent-hint
                            persistent-placeholder
                            placeholder="日付を選択"
                            readonly
                            rounded
                            style="font-size: 80%"
                            @click:clear="importFromDateClearEvent"
                          >
                            <template v-slot:append-outer>
                              <div
                                v-if="$vuetify.breakpoint.mdAndUp"
                                style="vertical-align: middle"
                              >
                                〜
                              </div>
                            </template>
                          </v-text-field>
                        </template>
                      </cs-date-picker>
                    </v-col>
                    <v-col cols="12" md="2">
                      <cs-date-picker
                        :date.sync="searchForm.import_to_date"
                        @dateChangedCallback="importToDateChangedCallback"
                      >
                        <template v-slot="{ on, attrs }">
                          <v-text-field
                            v-model="searchForm.import_to_date"
                            v-bind="attrs"
                            v-on="on"
                            append-icon="mdi-calendar"
                            clearable
                            dense
                            hide-details="auto"
                            label="終了日"
                            outlined
                            persistent-hint
                            persistent-placeholder
                            placeholder="日付を選択"
                            readonly
                            rounded
                            style="font-size: 80%"
                            @click:clear="importToDateClearEvent"
                          >
                            <template v-slot:append-outer>
                              <div
                                v-if="$vuetify.breakpoint.mdAndUp"
                                style="vertical-align: middle"
                              >
                                〜
                              </div>
                            </template>
                          </v-text-field>
                        </template>
                      </cs-date-picker>
                    </v-col>
                    <v-col cols="12" md="2">
                      <cs-date-picker
                        :date.sync="searchForm.collected_from_date"
                        @dateChangedCallback="collectedFromDateChangedCallback"
                      >
                        <template v-slot="{ on, attrs }">
                          <v-text-field
                            v-model="searchForm.collected_from_date"
                            v-bind="attrs"
                            v-on="on"
                            append-icon="mdi-calendar"
                            clearable
                            dense
                            hide-details="auto"
                            label="引渡し日"
                            outlined
                            persistent-hint
                            persistent-placeholder
                            placeholder="日付を選択"
                            readonly
                            rounded
                            style="font-size: 80%"
                            @click:clear="collectedFromDateClearEvent"
                          >
                            <template v-slot:append-outer>
                              <div
                                v-if="$vuetify.breakpoint.mdAndUp"
                                style="vertical-align: middle"
                              >
                                〜
                              </div>
                            </template>
                          </v-text-field>
                        </template>
                      </cs-date-picker>
                    </v-col>
                    <v-col cols="12" md="2">
                      <cs-date-picker
                        :date.sync="searchForm.collected_to_date"
                        @dateChangedCallback="collectedToDateChangedCallback"
                      >
                        <template v-slot="{ on, attrs }">
                          <v-text-field
                            v-model="searchForm.collected_to_date"
                            v-bind="attrs"
                            v-on="on"
                            append-icon="mdi-calendar"
                            clearable
                            dense
                            hide-details="auto"
                            label="終了日"
                            outlined
                            persistent-hint
                            persistent-placeholder
                            placeholder="日付を選択"
                            readonly
                            rounded
                            style="font-size: 80%"
                            @click:clear="collectedToDateClearEvent"
                          >
                          </v-text-field>
                        </template>
                      </cs-date-picker>
                    </v-col>
                  </v-row>
                  <!-- /マニフェスト番号, 照会日, 終了日, 引渡し日, 終了日 -->

                  <!-- 加入者番号, 排出事業者名, 排出事業場名, 収集運搬業者名 -->
                  <v-row>
                    <v-col cols="12" md="2">
                      <v-text-field
                        v-model="searchForm.subscriber_number"
                        clearable
                        dense
                        hide-details="auto"
                        label="加入者番号"
                        outlined
                        persistent-hint
                        persistent-placeholder
                        rounded
                        style="font-size: 80%"
                        @blur="searchButtonClickEvent"
                        @click:clear="() => {searchForm.subscriber_number = null; searchButtonClickEvent();}"
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="searchForm.emission_name"
                        clearable
                        dense
                        hide-details="auto"
                        label="排出事業者名"
                        outlined
                        persistent-hint
                        persistent-placeholder
                        rounded
                        style="font-size: 80%"
                        @blur="searchButtonClickEvent"
                        @click:clear="() => {searchForm.emission_name = null; searchButtonClickEvent();}"
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="searchForm.emission_location_name"
                        clearable
                        dense
                        hide-details="auto"
                        label="排出事業場名"
                        outlined
                        persistent-hint
                        persistent-placeholder
                        rounded
                        style="font-size: 80%"
                        @blur="searchButtonClickEvent"
                        @click:clear="() => {searchForm.emission_location_name = null; searchButtonClickEvent();}"
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="searchForm.transporter_name"
                        clearable
                        dense
                        hide-details="auto"
                        label="収集運搬業者名"
                        outlined
                        persistent-hint
                        persistent-placeholder
                        rounded
                        style="font-size: 80%"
                        @blur="searchButtonClickEvent"
                        @click:clear="() => {searchForm.transporter_name = null; searchButtonClickEvent();}"
                      />
                    </v-col>
                  </v-row>
                  <!-- /加入者番号, 排出事業者名, 排出事業場名, 収集運搬業者名 -->

                  <!-- 処分業者名, 処分事業場名, JWNET取扱品目 -->
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="searchForm.disposer_name"
                        clearable
                        dense
                        hide-details="auto"
                        label="処分業者名"
                        outlined
                        persistent-hint
                        persistent-placeholder
                        rounded
                        style="font-size: 80%"
                        @blur="searchButtonClickEvent"
                        @click:clear="() => {searchForm.disposer_name = null; searchButtonClickEvent();}"
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="searchForm.disposer_location_name"
                        clearable
                        dense
                        hide-details="auto"
                        label="処分事業場名"
                        outlined
                        persistent-hint
                        persistent-placeholder
                        rounded
                        style="font-size: 80%"
                        @blur="searchButtonClickEvent"
                        @click:clear="() => {searchForm.disposer_location_name = null; searchButtonClickEvent();}"
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <item-autocomplete
                        v-model="searchForm.item_ids"
                        :items="items"
                        classes="search-font"
                        clearable
                        dense
                        label="JWNET品目"
                        persistent-placeholder
                        outlined
                        rounded
                        multiple
                        chips
                        small-chips
                        deletable-chips
                        @change="searchButtonClickEvent()"
                      />
                    </v-col>
                  </v-row>
                  <!-- /処分業者名, 処分事業場名, JWNET取扱品目 -->

                  <!-- 運搬報告状況, 運搬終了日 (from), 運搬終了日 (to), 運搬報告区間指定 -->
                  <v-row>
                    <v-col cols="12" md="2">
                      <v-select
                        v-model="searchForm.transport_report_state"
                        :items="transportReportStatus"
                        clearable
                        background-color="white"
                        dense
                        hide-details="auto"
                        label="運搬報告状況"
                        outlined
                        persistent-placeholder
                        rounded
                        style="font-size: 80%"
                        @change="searchButtonClickEvent"
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <cs-date-picker
                        :date.sync="searchForm.transport_completed_from_date"
                        @dateChangedCallback="transportCompletedFromDateChangedCallback"
                      >
                        <template v-slot="{ on, attrs }">
                          <v-text-field
                            v-model="searchForm.transport_completed_from_date"
                            v-bind="attrs"
                            v-on="on"
                            append-icon="mdi-calendar"
                            clearable
                            dense
                            hide-details="auto"
                            label="運搬終了日 (from)"
                            outlined
                            persistent-hint
                            persistent-placeholder
                            placeholder="日付を選択"
                            readonly
                            rounded
                            style="font-size: 80%"
                            @click:clear="transportCompletedFromDateClearEvent"
                          >
                            <template v-slot:append-outer>
                              <div
                                v-if="$vuetify.breakpoint.mdAndUp"
                                style="vertical-align: middle"
                              >
                                〜
                              </div>
                            </template>
                          </v-text-field>
                        </template>
                      </cs-date-picker>
                    </v-col>
                    <v-col cols="12" md="2">
                      <cs-date-picker
                        :date.sync="searchForm.transport_completed_to_date"
                        @dateChangedCallback="transportCompletedToDateChangedCallback"
                      >
                        <template v-slot="{ on, attrs }">
                          <v-text-field
                            v-model="searchForm.transport_completed_to_date"
                            v-bind="attrs"
                            v-on="on"
                            append-icon="mdi-calendar"
                            clearable
                            dense
                            hide-details="auto"
                            label="運搬終了日 (to)"
                            outlined
                            persistent-hint
                            persistent-placeholder
                            placeholder="日付を選択"
                            readonly
                            rounded
                            style="font-size: 80%"
                            @click:clear="transportCompletedToDateClearEvent"
                          />
                        </template>
                      </cs-date-picker>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-select
                        v-model="searchForm.section_no"
                        :items="sectionNos"
                        clearable
                        background-color="white"
                        dense
                        hide-details="auto"
                        label="運搬報告区間指定"
                        outlined
                        persistent-placeholder
                        rounded
                        style="font-size: 80%"
                        @change="searchButtonClickEvent"
                      />
                    </v-col>
                  </v-row>
                  <!-- /運搬報告状況, 運搬終了日 (from), 運搬終了日 (to), 運搬報告区間指定 -->

                  <!-- 処分報告状況, 処分終了日 (from), 処分終了日 (to) -->
                  <v-row>
                    <v-col cols="12" md="2">
                      <v-select
                        v-model="searchForm.disposal_report_state"
                        :items="disposalReportStatus"
                        clearable
                        background-color="white"
                        dense
                        hide-details="auto"
                        label="処分報告状況"
                        outlined
                        persistent-placeholder
                        rounded
                        style="font-size: 80%"
                        @change="searchButtonClickEvent"
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <cs-date-picker
                        :date.sync="searchForm.disposal_completed_from_date"
                        @dateChangedCallback="disposalCompletedFromDateChangedCallback"
                      >
                        <template v-slot="{ on, attrs }">
                          <v-text-field
                            v-model="searchForm.disposal_completed_from_date"
                            v-bind="attrs"
                            v-on="on"
                            append-icon="mdi-calendar"
                            clearable
                            dense
                            hide-details="auto"
                            label="処分終了日 (from)"
                            outlined
                            persistent-hint
                            persistent-placeholder
                            placeholder="日付を選択"
                            readonly
                            rounded
                            style="font-size: 80%"
                            @click:clear="disposalCompletedFromDateClearEvent"
                          >
                            <template v-slot:append-outer>
                              <div
                                v-if="$vuetify.breakpoint.mdAndUp"
                                style="vertical-align: middle"
                              >
                                〜
                              </div>
                            </template>
                          </v-text-field>
                        </template>
                      </cs-date-picker>
                    </v-col>
                    <v-col cols="12" md="2">
                      <cs-date-picker
                        :date.sync="searchForm.disposal_completed_to_date"
                        @dateChangedCallback="disposalCompletedToDateChangedCallback"
                      >
                        <template v-slot="{ on, attrs }">
                          <v-text-field
                            v-model="searchForm.disposal_completed_to_date"
                            v-bind="attrs"
                            v-on="on"
                            append-icon="mdi-calendar"
                            clearable
                            dense
                            hide-details="auto"
                            label="処分終了日 (to)"
                            outlined
                            persistent-hint
                            persistent-placeholder
                            placeholder="日付を選択"
                            readonly
                            rounded
                            style="font-size: 80%"
                            @click:clear="disposalCompletedToDateClearEvent"
                          />
                        </template>
                      </cs-date-picker>
                    </v-col>
                  </v-row>
                  <!-- /処分報告状況, 処分終了日 (from), 処分終了日 (to) -->

                  <!-- 最終報告状況, 最終終了日 (from), 最終終了日 (to) -->
                  <v-row>
                    <v-col cols="12" md="2">
                      <v-select
                        v-model="searchForm.final_report_state"
                        :items="finalReportStatus"
                        clearable
                        background-color="white"
                        dense
                        hide-details="auto"
                        label="最終報告状況"
                        outlined
                        persistent-placeholder
                        rounded
                        style="font-size: 80%"
                        @change="searchButtonClickEvent"
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <cs-date-picker
                        :date.sync="searchForm.final_disposal_from_date"
                        @dateChangedCallback="finalDisposalFromDateChangedCallback"
                      >
                        <template v-slot="{ on, attrs }">
                          <v-text-field
                            v-model="searchForm.final_disposal_from_date"
                            v-bind="attrs"
                            v-on="on"
                            append-icon="mdi-calendar"
                            clearable
                            dense
                            hide-details="auto"
                            label="最終終了日 (from)"
                            outlined
                            persistent-hint
                            persistent-placeholder
                            placeholder="日付を選択"
                            readonly
                            rounded
                            style="font-size: 80%"
                            @click:clear="finalDisposalFromDateClearEvent"
                          >
                            <template v-slot:append-outer>
                              <div
                                v-if="$vuetify.breakpoint.mdAndUp"
                                style="vertical-align: middle"
                              >
                                〜
                              </div>
                            </template>
                          </v-text-field>
                        </template>
                      </cs-date-picker>
                    </v-col>
                    <v-col cols="12" md="2">
                      <cs-date-picker
                        :date.sync="searchForm.final_disposal_to_date"
                        @dateChangedCallback="finalDisposalToDateChangedCallback"
                      >
                        <template v-slot="{ on, attrs }">
                          <v-text-field
                            v-model="searchForm.final_disposal_to_date"
                            v-bind="attrs"
                            v-on="on"
                            append-icon="mdi-calendar"
                            clearable
                            dense
                            hide-details="auto"
                            label="最終終了日 (to)"
                            outlined
                            persistent-hint
                            persistent-placeholder
                            placeholder="日付を選択"
                            readonly
                            rounded
                            style="font-size: 80%"
                            @click:clear="finalDisposalToDateClearEvent"
                          />
                        </template>
                      </cs-date-picker>
                    </v-col>
                  </v-row>
                  <!-- /最終報告状況, 最終終了日 (from), 最終終了日 (to)-->

                  <!-- 未紐付けのみ, 表示順  -->
                  <v-row>
                    <v-col cols="12" md="4" class="pt-0">
                      <p class="mb-0">未紐付けのみ</p>
                      <v-radio-group row dense class="mt-0 pt-0" hide-details="auto">
                        <v-checkbox
                          v-model="searchForm.supplierable_state_unlinked"
                          class="mt-0"
                          dense
                          hide-details="auto"
                          label="排出"
                          @click="() => { searchButtonClickEvent(); }"
                        />&emsp;
                        <v-checkbox
                          v-model="searchForm.trader_state_unlinked"
                          class="mt-0"
                          dense
                          hide-details="auto"
                          label="業者"
                          @click="() => { searchButtonClickEvent(); }"
                        />&emsp;
                        <v-checkbox
                          v-model="searchForm.none_reporting_state_unlinked"
                          class="mt-0"
                          dense
                          hide-details="auto"
                          label="不要"
                          @click="() => { searchButtonClickEvent(); }"
                        />&emsp;
                        <v-checkbox
                          v-model="searchForm.public_place_state_unlinked"
                          class="mt-0"
                          dense
                          hide-details="auto"
                          label="公共"
                          @click="() => { searchButtonClickEvent(); }"
                        />
                      </v-radio-group>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-select
                        v-model="searchForm.sort_type"
                        :items="sortTypes"
                        dense
                        hide-details="auto"
                        label="表示順"
                        outlined
                        persistent-placeholder
                        rounded
                        style="font-size: 80%"
                        @change="searchButtonClickEvent"
                      />
                    </v-col>
                  </v-row>
                  <!-- /未紐付けのみ, 表示順  -->

                </v-card-text>
                <v-divider />
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="primary"
                    @click="searchButtonClickEvent"
                  >
                    検索
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>

    <!-- ページャ -->
    <v-row class="white">
      <v-col cols="12" md="6" style="vertical-align: middle">
        <div class="ml-2">
          <v-btn
            color="primary"
            large
            width="150"
            :disabled="isAutoConfiguring"
            :loading="isAutoConfiguring"
            @click="autoConfigurationButtonClickEvent"
          >
            紐付け処理
          </v-btn>
          <div
            class="d-xl-inline-block d-sm-inline-block d-md-inline d-lg-inline mt-4"
            :class="$vuetify.breakpoint.mdAndUp ? 'ml-2' : ''"
          >
          <span>
            <v-icon
              :color="iconColor('untouched')"
              class="ml-2"
              small
            >
              {{ iconMarker('untouched') }}
            </v-icon>
            : <small>紐付け前</small>
          </span>
            <span>
            <v-icon
              :color="iconColor('excluded')"
              class="ml-2"
              small
            >
              {{ iconMarker('excluded') }}
            </v-icon>
            : <small>紐付け対象なし</small>
          </span>
          <span>
            <v-icon
              :color="iconColor('negative')"
              class="ml-2"
              small
            >
              {{ iconMarker('negative') }}
            </v-icon>
            : <small>未紐付け</small>
          </span>
            <span>
            <v-icon
              :color="iconColor('pending')"
              class="ml-2"
              small
            >
              {{ iconMarker('pending') }}
            </v-icon>
            : <small>紐付け処理中</small>
          </span>
            <span>
            <v-icon
              :color="iconColor('positive')"
              class="ml-2"
              small
            >
              {{ iconMarker('positive') }}
            </v-icon>
            : <small>紐付け済み</small>
          </span>
          </div>
        </div>

      </v-col>
      <v-col cols="12" md="6">
        <custom-pagination
          :page-number="page"
          :per-page="searchForm.limit"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="pageChangeEvent"
          @perPageChanged="perPageChangeEvent"
        >
        </custom-pagination>
      </v-col>
    </v-row>
    <!-- /ページャ -->

    <!-- JWNETマニフェスト一覧 -->
    <v-row>
      <v-col cols="12">
        <v-data-table
          v-model="selectedManifests"
          :headers="tableHeaders"
          :items="transferManifests"
          :items-per-page="-1"
          hide-default-footer
          disable-sort
          show-select
          @toggle-select-all="selectAllToggleClickEvent"
          @click:row="toggleRowSelection"
        >
          <!-- チェックボックス -->
          <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
            <v-simple-checkbox
              :value="isSelected"
              :disabled="item.disabled"
              :indeterminate="item.disabled"
              :readonly="item.disabled"
              :ripple="false"
              @input="select($event)"
            />
          </template>
          <!-- /チェックボックス -->

          <!-- マニフェスト番号/状態 -->
          <template v-slot:[`item.manifest_no`]="{item}">
            <div>{{ item.manifest_no }}</div>
            <div>
              <v-chip
                v-if="item.dxe_imported"
                title="更新"
                label
                x-small
              >
                更新
              </v-chip>
              <v-chip
                v-else
                title="新規"
                color="info"
                label
                x-small
              >
                新規
              </v-chip>

            </div>
          </template>
          <!-- /マニフェスト番号/状態 -->

          <!-- 照会日/排出/業者/不要/公共 -->
          <template v-slot:[`item.status`]="{ item }">
            <div>{{ item.inquiry_date | date_format }}</div>
            <template v-if="item.import_completed">
              <v-chip label x-small>取込済</v-chip>
            </template>
            <template v-else>
              <v-icon
                :color="iconColor(item.emission_situation)"
                class="mx-1"
                small
              >
                {{ iconMarker(item.emission_situation) }}
              </v-icon>
              <v-icon
                :color="iconColor(item.transports_situation)"
                class="mx-1"
                small
              >
                {{ iconMarker(item.transports_situation) }}
              </v-icon>
              <v-icon
                :color="iconColor(item.none_report_situation)"
                class="mx-1"
                small
              >
                {{ iconMarker(item.none_report_situation) }}
              </v-icon>
              <v-icon
                :color="iconColor(item.public_situation)"
                class="mx-1"
                small
              >
                {{ iconMarker(item.public_situation) }}
              </v-icon>
            </template>
          </template>
          <!-- /照会日/排出/業者/不要/公共 -->

          <template v-slot:[`item.jwnet_emission`]="{ item }">
            <div>{{ item.subscriber_no }}</div>
            <div
              class="text-ellipsis text-sm-caption"
              :title="item.jwnet_emission_name"
              style="width: 150px;"
            >{{ item.jwnet_emission_name }}</div>
          </template>
          <template v-slot:[`item.dxe_emission`]="{ item }">
            <div v-if="item.emission_code">
              <div>{{ item.emission_code }}</div>
              <div
                :title="item.emission_name"
                class="text-ellipsis text-sm-caption"
                style="width: 150px;"
              >{{ item.emission_name }}</div>
            </div>
            <div v-else>
              <div class="pa-4">-</div>
            </div>
          </template>
          <template v-slot:[`item.jwnet_location_name`]="{ item }">
            <div
              class="text-ellipsis text-sm-caption"
              :title="item.jwnet_location_name"
              style="width: 150px;"
            >{{ item.jwnet_location_name }}</div>
          </template>
          <template v-slot:[`item.collected_date`]="{ item }">
            <div>{{ item.collected_date | date_format }}</div>
            <div>
              <v-chip
                :title="item.item_name"
                color="#F0E6D0"
                label
                x-small
              >
                {{ item.item_name | truncate(10) }}
              </v-chip>
            </div>
          </template>
          <template v-slot:[`item.quantity`]="{ item }">
            <div class="text-right">{{ item.quantity }}</div>
            <div class="text-right">{{ item.quantity_unit }}</div>
          </template>
          <template v-slot:[`item.quantity_confirm`]="{ item }">
            <div
              class="text-ellipsis text-sm-caption"
              :title="item.disposer_location_name"
              style="width: 150px;"
            >{{ item.disposer_location_name }}</div>
            <div><small>{{ item.disposal_method }}&nbsp;</small></div>
          </template>
          <template v-slot:[`item.completed_date`]="{ item }">
            {{ item.completed_date | date_format }}&nbsp;
          </template>
          <template v-slot:[`item.disposal_date`]="{ item }">
            <div>{{ item.disposal_report_date }}&nbsp;</div>
            <div>{{ item.final_disposal_date }}&nbsp;</div>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn
              :icon="$vuetify.breakpoint.mdAndUp"
              color="info darken-2"
              @click="showButtonClickEvent(item)"
            >
              <v-icon v-if="$vuetify.breakpoint.mdAndUp">mdi-file-document-outline</v-icon>
              <span v-else>詳細</span>
            </v-btn>

          </template>
        </v-data-table>
        <confirm ref="confirm" />
      </v-col>
    </v-row>
    <!-- /JWNETマニフェスト一覧 -->

    <!-- ページャ -->
    <v-row class="mb-15">
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="searchForm.limit"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="pageChangeEvent"
          @perPageChanged="perPageChangeEvent"
        />
      </v-col>
    </v-row>
    <!-- /ページャ -->

    <v-footer fixed class="mb-13" color="white" width="100%;" style="overflow-x: auto;">
      <v-card flat width="100%">
        <v-card-actions>
          <template v-if="$vuetify.breakpoint.smAndDown && false">
            <v-menu offset-y top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  :disabled="enableCallButton"
                  color="primary"
                  large
                  width="100"
                >
                  操作
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="emissionComplementButtonClickEvent">
                  <v-list-item-title>排出事業者</v-list-item-title>
                </v-list-item>

                <v-list-item @click="traderComplementButtonClickEvent">
                  <v-list-item-title>収運・処分業者</v-list-item-title>
                </v-list-item>

                <v-list-item @click="noneReportingComplementButtonClickEvent">
                  <v-list-item-title>報告不要業者</v-list-item-title>
                </v-list-item>

                <v-list-item @click="publicPlaceComplementButtonClickEvent">
                  <v-list-item-title>公共事業場</v-list-item-title>
                </v-list-item>

              </v-list>
            </v-menu>&nbsp;
            <v-btn
              :disabled="enableCallButton"
              color="error"
              class="mr-3"
              large
              width="120"
              @click="deleteManifestButtonClickEvent"
            >
              削除
            </v-btn>
          </template>
          <template v-else>
            <v-btn
              :disabled="enableCallButton"
              color="primary"
              large
              width="130"
              @click="emissionComplementButtonClickEvent"
            >
              排出事業者
            </v-btn>
            <v-btn
              :disabled="enableCallButton"
              color="primary"
              large
              width="130"
              @click="traderComplementButtonClickEvent"
            >
              収運・処分業者
            </v-btn>
            <v-btn
              :disabled="enableCallButton"
              color="primary"
              large
              width="130"
              @click="noneReportingComplementButtonClickEvent"
            >
              報告不要業者
            </v-btn>
            <v-btn
              :disabled="enableCallButton"
              color="primary"
              large
              width="130"
              @click="publicPlaceComplementButtonClickEvent"
            >
              公共事業場
            </v-btn>
            <v-btn
              :disabled="enableCallButton"
              color="error"
              class="mr-3"
              large
              width="130"
              @click="deleteManifestButtonClickEvent"
            >
              削除
            </v-btn>
          </template>
          <v-spacer />
          <v-btn
            :disabled="enableCallButton"
            color="primary"
            class="mr-3"
            large
            width="130"
            @click="importManifestButtonClickEvent"
          >
            取込
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-footer>

    <!-- 排出事業者データ補完 -->
    <emission-complement-modal
      :dialog="emissionComplement"
      :selectable-ids="selectableIds"
      :searched-at="searched_at"
      @closeCallback="dialogCloseCallback"
      @registerCallback="dialogRegisterCallback"
    />
    <!-- /排出事業者データ補完 -->

    <!-- 収運・処分業者データ補完 -->
    <trader-complement-modal
      :dialog="traderComplement"
      :selectable-ids="selectableIds"
      :searched-at="searched_at"
      @closeCallback="dialogCloseCallback"
      @registerCallback="dialogRegisterCallback"
    />
    <!-- /収運・処分業者データ補完 -->

    <!-- 報告不要データ補完 -->
    <none-report-trader-complement-modal
      :dialog="noneReportTraderComplement"
      :selectable-ids="selectableIds"
      :searched-at="searched_at"
      @closeCallback="dialogCloseCallback"
      @registerCallback="dialogRegisterCallback"
    />
    <!-- /報告不要データ補完 -->

    <!-- 公共積替データ補完 -->
    <public-place-complement-modal
      :dialog="publicPlaceComplement"
      :selectable-ids="selectableIds"
      :searched-at="searched_at"
      @closeCallback="dialogCloseCallback"
      @registerCallback="dialogRegisterCallback"
    />
    <!-- /公共積替データ補完 -->

    <v-dialog
      v-model="enableImportErrorMessageDialog"
      width="700"
      scrollable
      @click:outside="dialogCloseCallback"
    >
      <v-card>
        <v-toolbar
          color="error"
          dark
          flat
        >
          <v-toolbar-title>
            確認
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn
              icon
              dark
              @click="dialogCloseCallback"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-subtitle class="mt-4">
          <h3>
            以下のマニフェストはスキップされました。
          </h3>
        </v-card-subtitle>
        <v-card-text style="max-height: 300px;">
          <ul v-if="importErrorMessages">
            <li
              v-for="(errorMessage, index) in importErrorMessages"
              :key="index"
              v-html="errorMessage"
            />
          </ul>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="dialogCloseCallback"
          >
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>
